function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//  @jsx h

/* eslint-disable jsx-a11y/media-has-caption */
import { h } from 'preact';
import PureComponent from '../../lib/preact-pure-component';

class Video extends PureComponent {
  constructor() {
    super(...arguments);

    _defineProperty(this, "elm", void 0);

    _defineProperty(this, "state", {
      isPlaying: false,
      isResolvingPlay: false,
      time: 0
    });

    _defineProperty(this, "tracks", []);

    _defineProperty(this, "handlePlay", () => {
      const onPlay = this.props.onPlay;
      this.setState({
        isPlaying: true
      });

      if (onPlay) {
        onPlay();
      }
    });

    _defineProperty(this, "handlePause", () => {
      const onPause = this.props.onPause;
      this.setState({
        isPlaying: false
      });

      if (onPause) {
        onPause();
      }
    });

    _defineProperty(this, "handleDurationChange", () => {
      const onDurationChange = this.props.onDurationChange;

      if (onDurationChange && this.elm) {
        onDurationChange(this.elm.duration);
      }
    });

    _defineProperty(this, "handleTimeupdate", () => {
      const onTimeupdate = this.props.onTimeupdate;
      const time = this.elm.currentTime;
      this.setState({
        time
      });

      if (onTimeupdate) {
        onTimeupdate(time);
      }
    });
  }

  componentDidMount() {
    const _this$props = this.props,
          textTracks = _this$props.textTracks,
          playing = _this$props.playing,
          onCaptionCueEnter = _this$props.onCaptionCueEnter,
          onCaptionCueExit = _this$props.onCaptionCueExit;

    if (textTracks) {
      textTracks.forEach(textTrack => {
        const track = this.elm.addTextTrack('subtitles', textTrack.language);
        track.mode = 'hidden';
        this.tracks.push(track);

        try {
          textTrack.captions.forEach(a => track.addCue(new window.VTTCue(Number(a.in), Number(a.out), a.text)));
        } catch (_) {
          // ignore error
          textTrack.captions.forEach(a => track.addCue(new window.TextTrackCue(Number(a.in), Number(a.out), a.text)));
        }

        for (let i = 0; i < track.cues.length; i++) {
          const cue = track.cues[i];

          try {
            cue.onenter = () => {
              if (typeof onCaptionCueEnter !== 'undefined') {
                onCaptionCueEnter({
                  in: cue.startTime,
                  out: cue.endTime,
                  text: cue.text
                });
              }
            };

            cue.onexit = () => {
              if (typeof onCaptionCueExit !== 'undefined') {
                onCaptionCueExit();
              }
            };
          } catch (_) {// ignore error
          }
        }
      });
    }

    if (playing) {
      this.play();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.playing !== this.props.playing) {
      if (this.props.playing) {
        this.play();
      } else {
        this.pause();
      }
    }
  }

  play() {
    const onError = this.props.onError;
    const playPromise = this.elm.play();

    if (playPromise) {
      this.setState({
        isResolvingPlay: true
      });
      playPromise.then(() => {
        this.setState({
          isResolvingPlay: false
        });
      }).catch(err => {
        if (onError) {
          onError(err.message);
        }

        this.setState({
          isResolvingPlay: false
        });
      });
    }
  }

  pause() {
    this.elm.pause();
  }

  seek(time) {
    this.elm.currentTime = time;
  }

  render() {
    const _this$props2 = this.props,
          playing = _this$props2.playing,
          sources = _this$props2.sources,
          restProps = _objectWithoutProperties(_this$props2, ["playing", "sources"]);

    const isPlaying = this.state.isPlaying;
    const eventHandlers = {
      onPlay: this.handlePlay,
      onPause: this.handlePause,
      onDurationChange: this.handleDurationChange,
      onTimeupdate: this.handleTimeupdate
    };
    const dataProps = {};

    if (isPlaying) {
      dataProps['data-playing'] = true;
    }

    return h("video", _extends({}, restProps, eventHandlers, {
      ref: elm => this.elm = elm
    }, dataProps), sources.map(source => h("source", _extends({}, source, {
      key: source.type
    }))));
  }

}

export default Video;